import type { Me } from '@volee/api-client'
import { Badge, MutedText } from '@volee/ui'

import { interpolate, messages, staffRoleLine } from '../messages/index.ts'

/** Says there is no Cognito session behind this identity. Rendered by the menu and the row. */
export function DevBypassBadge() {
  return <Badge variant="warning">{messages.session.devBypass}</Badge>
}

/** Who is signed in, on one line: for a page that has room to say it outright. */
export function SessionIdentity({ me }: { me: Me }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <MutedText>{interpolate(messages.dashboard.signedInAs, { email: me.email })}</MutedText>
      <MutedText>·</MutedText>
      <MutedText>{staffRoleLine(me)}</MutedText>
      {me.is_dev_bypass ? <DevBypassBadge /> : null}
    </div>
  )
}
